module.exports = __webpack_public_path__ + "static/media/img-app-interview-rescheduling.522b7a0a.png";